import { decodeJwtClaims } from "@lib/authentication/jwt";
import { getSnapshot } from "@lib/authentication/SessionStore";

// Convenzione BE (DiscoveryResource: replaceFirst("^mydriveby-tenant-")): i realm
// dei macro-clienti sono "mydriveby-tenant-<slug>"; tutto il resto è piattaforma.
// Il decoy mydriveby-void non emette mai token → non produce sessioni.
export const TENANT_REALM_PREFIX = "mydriveby-tenant-";

/** Nome del realm dal claim `iss` (segmento dopo "/realms/"), o null. */
export function realmFromIss(iss: string | undefined): string | null {
  if (!iss) return null;
  const marker = "/realms/";
  const index = iss.lastIndexOf(marker);
  if (index < 0) return null;
  const realm = iss.slice(index + marker.length).split("/")[0].trim();
  return realm.length > 0 ? realm : null;
}

/** True se il token è emesso da un realm non-tenant (sessione di piattaforma). */
export function isPlatformToken(accessToken: string): boolean {
  const claims = decodeJwtClaims<{ iss?: string }>(accessToken);
  const realm = realmFromIss(claims?.iss);
  return realm !== null && !realm.startsWith(TENANT_REALM_PREFIX);
}

/** Ruoli realm dal JWT (realm_access.roles) per il bootstrap senza /me. */
export function realmRolesFromToken(accessToken: string): string[] {
  const claims = decodeJwtClaims<{ realm_access?: { roles?: unknown } }>(accessToken);
  const roles = claims?.realm_access?.roles;
  return Array.isArray(roles) ? roles.map(String) : [];
}

/** True se la sessione corrente è di piattaforma (routing post-login). */
export function isPlatformSession(): boolean {
  const info = getSnapshot().session.info;
  return info?.token ? isPlatformToken(info.token) : false;
}
